// extracted by mini-css-extract-plugin
export default {"container":"CTABanner_container__G5UrQ","iconWrapper":"CTABanner_iconWrapper__ZN-MI","contentWrapper":"CTABanner_contentWrapper__MJMPa","button":"CTABanner_button__BsVJV"};